export default __webpack_public_path__ + "static/media/Small Freeze Bomb.0c15c03d.PNG";